import {
  Component,
  Element,
  Event,
  type EventEmitter,
  h,
  Prop
} from '@stencil/core';
import actionDeleteCross from '@se/icons/svg/action_delete_cross.svg';
import type { FacetValue } from '../../../api/model/response/facets/Facets';
import type {FilterNode} from '../../result-page/facets-build-wrapper/filter-node';

@Component({
  tag: 'svs-chip',
  styleUrl: 'svs-chip.scss',
  shadow: true
})
export class ChipComponent {
  @Element() el: HTMLElement;
  /**
   * The text you want to display in your chip.
   */
  @Prop() readonly name: string;

  /**
   * The filter details
   */
  @Prop() readonly filterData: FacetValue | FilterNode;

  /**
   * Indicates whether or not the chip is disabled. Set to false by default
   */
  @Prop() readonly disabled: boolean = false;

  /**
   * Read-only chip without close button and click action
   */
  @Prop() readonly readOnly: boolean = false;

  /**
   * Send the chip value to the parent component when clicking the close button of a chip.
   */
  @Event({
    eventName: 'close:chip',
    bubbles: true
  })
    didClose: EventEmitter<FacetValue|FilterNode>;

  /**
   * The width of the chip. Defaults to auto.
   */
  @Prop() readonly width?: string;

  private closeChip = () => {
      if (!this.disabled) {
        this.didClose.emit(this.filterData);
      }
  };

  render() {
      const svsChipClassName = `svs-chip${this.readOnly ? '-read-only' : ''}`;

      return (
        <button
          onClick={this.closeChip}
          disabled={this.disabled}
          style={{'width': this.width !== undefined ? this.width : 'auto'}}
          class={{
            [svsChipClassName]: true,
            clickable: !this.disabled && !this.readOnly,
          }}
        >
          {this.name && (
            <div
              style={{'width': this.width !== undefined ? this.width : 'auto'}}
              class={`value${this.readOnly ? '-read-only' : ''}`}
              title={this.name}
            >
              {this.name}
            </div>
          )}
          {this.readOnly ? (
            ''
          ) : (
            <se-icon
              class="close"
              //@ts-ignore
              option="icon"
              size="small"
              no-hover
              disabled={this.disabled}
            >
              <span innerHTML={actionDeleteCross}></span>
            </se-icon>
          )}
        </button>
      );
  }
}
